
define('core/node_path',["require", "exports", './node_process'], function(require, exports, node_process) {
    var process = node_process.process;

    var path = (function () {
        function path() {
        }
        path.normalize = function (p) {
            if (p === '') {
                p = '.';
            }

            var absolute = p.charAt(0) === path.sep;

            p = path._removeDuplicateSeps(p);

            var components = p.split(path.sep);
            var goodComponents = [];
            for (var idx = 0; idx < components.length; idx++) {
                var c = components[idx];
                if (c === '.') {
                    continue;
                } else if (c === '..' && (absolute || (!absolute && goodComponents.length > 0 && goodComponents[0] !== '..'))) {
                    goodComponents.pop();
                } else {
                    goodComponents.push(c);
                }
            }

            if (!absolute && goodComponents.length < 2) {
                switch (goodComponents.length) {
                    case 1:
                        if (goodComponents[0] === '') {
                            goodComponents.unshift('.');
                        }
                        break;
                    default:
                        goodComponents.push('.');
                }
            }
            p = goodComponents.join(path.sep);
            if (absolute && p.charAt(0) !== path.sep) {
                p = path.sep + p;
            }
            return p;
        };

        path.join = function () {
            var paths = [];
            for (var _i = 0; _i < (arguments.length - 0); _i++) {
                paths[_i] = arguments[_i + 0];
            }
            var processed = [];
            for (var i = 0; i < paths.length; i++) {
                var segment = paths[i];
                if (typeof segment !== 'string') {
                    throw new TypeError("Invalid argument type to path.join: " + (typeof segment));
                } else if (segment !== '') {
                    processed.push(segment);
                }
            }
            return path.normalize(processed.join(path.sep));
        };

        path.resolve = function () {
            var paths = [];
            for (var _i = 0; _i < (arguments.length - 0); _i++) {
                paths[_i] = arguments[_i + 0];
            }
            var processed = [];
            for (var i = 0; i < paths.length; i++) {
                var p = paths[i];
                if (typeof p !== 'string') {
                    throw new TypeError("Invalid argument type to path.join: " + (typeof p));
                } else if (p !== '') {
                    if (p.charAt(0) === path.sep) {
                        processed = [];
                    }
                    processed.push(p);
                }
            }

            var resolved = path.normalize(processed.join(path.sep));
            if (resolved.length > 1 && resolved.charAt(resolved.length - 1) === path.sep) {
                return resolved.substr(0, resolved.length - 1);
            }

            if (resolved.charAt(0) !== path.sep) {
                if (resolved.charAt(0) === '.' && (resolved.length === 1 || resolved.charAt(1) === path.sep)) {
                    resolved = resolved.length === 1 ? '' : resolved.substr(2);
                }

                var cwd = process.cwd();
                if (resolved !== '') {
                    resolved = this.normalize(cwd + (cwd !== '/' ? path.sep : '') + resolved);
                } else {
                    resolved = cwd;
                }
            }
            return resolved;
        };

        path.relative = function (from, to) {
            var i;

            from = path.resolve(from);
            to = path.resolve(to);
            var fromSegs = from.split(path.sep);
            var toSegs = to.split(path.sep);

            toSegs.shift();
            fromSegs.shift();

            var upCount = 0;
            var downSegs = [];

            for (i = 0; i < fromSegs.length; i++) {
                var seg = fromSegs[i];
                if (seg === toSegs[i]) {
                    continue;
                }

                upCount = fromSegs.length - i;
                break;
            }

            downSegs = toSegs.slice(i);

            if (fromSegs.length === 1 && fromSegs[0] === '') {
                upCount = 0;
            }

            if (upCount > fromSegs.length) {
                upCount = fromSegs.length;
            }

            var rv = '';
            for (i = 0; i < upCount; i++) {
                rv += '../';
            }
            rv += downSegs.join(path.sep);

            if (rv.length > 1 && rv.charAt(rv.length - 1) === path.sep) {
                rv = rv.substr(0, rv.length - 1);
            }
            return rv;
        };

        path.dirname = function (p) {
            p = path._removeDuplicateSeps(p);
            var absolute = p.charAt(0) === path.sep;
            var sections = p.split(path.sep);

            if (sections.pop() === '' && sections.length > 0) {
                sections.pop();
            }
            if (sections.length > 1) {
                return sections.join(path.sep);
            } else if (absolute) {
                return path.sep;
            } else {
                return '.';
            }
        };

        path.basename = function (p, ext) {
            if (typeof ext === "undefined") { ext = ""; }
            if (p === '') {
                return p;
            }

            p = path.normalize(p);

            var sections = p.split(path.sep);
            var lastPart = sections[sections.length - 1];

            if (lastPart === '' && sections.length > 1) {
                return sections[sections.length - 2];
            }

            if (ext.length > 0) {
                var lastPartExt = lastPart.substr(lastPart.length - ext.length);
                if (lastPartExt === ext) {
                    return lastPart.substr(0, lastPart.length - ext.length);
                }
            }
            return lastPart;
        };

        path.extname = function (p) {
            p = path.normalize(p);
            var sections = p.split(path.sep);
            p = sections.pop();

            if (p === '' && sections.length > 0) {
                p = sections.pop();
            }
            if (p === '..') {
                return '';
            }
            var i = p.lastIndexOf('.');
            if (i === -1 || i === 0) {
                return '';
            }
            return p.substr(i);
        };

        path.isAbsolute = function (p) {
            return p.length > 0 && p.charAt(0) === path.sep;
        };

        path._makeLong = function (p) {
            return p;
        };

        path._removeDuplicateSeps = function (p) {
            p = p.replace(this._replaceRegex, this.sep);
            return p;
        };
        path.sep = '/';

        path._replaceRegex = new RegExp("//+", 'g');

        path.delimiter = ':';
        return path;
    })();
    exports.path = path;
});
//# sourceMappingURL=node_path.js.map
;